import DataSchemaDetailsContainer from './components/DataSchemaDetailsContainer';

import configuration from './pages/configuration';
import schema from './pages/schema';
import createDataWizard from './pages/create-data-wizard';
import orgSchemas from './pages/overview/org-schemas';
import sharedSchemas from './pages/overview/shared-schemas';

const passthrough = props => props.children;

export default store => ({
  path: 'data-schemas',

  component: passthrough,

  indexRoute: {
    onEnter: (nextState, replace) => replace('/data-schemas/overview')
  },

  childRoutes: [
    {
      path: 'overview',
      indexRoute: {
        onEnter: (nextState, replace) =>
          replace('/data-schemas/overview/org-schemas')
      },
      getComponent(nextState, cb) {
        import('./components/DataSchemaOverviewContainer')
          .then(component => {
            return cb(null, component.default);
          })
          .catch(errorLoading);
      },
      childRoutes: [
        orgSchemas,
        sharedSchemas,
        // wizard is a child of overview because the wizard opens in a modal over the top of overview
        createDataWizard
      ].map(r => r(store))
    },
    {
      path: ':dataSchemaId',
      indexRoute: {
        onEnter: ({ location }, replace) => {
          replace(`${location.pathname}/configuration`);
        }
      },
      component: DataSchemaDetailsContainer,
      childRoutes: [schema, configuration].map(r => r(store))
    }
  ]
});

function errorLoading(err) {
  console.error('Dynamic page loading failed', err);
}



// WEBPACK FOOTER //
// ./src/client/plugins/structured-data/index.js